import React, { useState, useEffect } from 'react';
import { FaCookie, FaTimes } from 'react-icons/fa';

const CookiePopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9998] p-4 animate-slide-up">
      <div className="glass rounded-xl p-6 max-w-4xl mx-auto border-2 border-neon-blue/30 shadow-2xl">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-neon-blue to-neon-purple flex items-center justify-center">
              <FaCookie className="text-xl text-white" />
            </div>
          </div>
          
          <div className="flex-1">
            <h3 className="text-xl font-bold text-white mb-2">We Value Your Privacy</h3>
            <p className="text-gray-400 text-sm mb-4">
              SpinTitanium uses cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
              By clicking "Accept All", you consent to our use of cookies. You can manage your preferences at any time.
            </p>
            
            <div className="flex flex-wrap gap-3">
              <button
                onClick={acceptCookies}
                className="bg-gradient-to-r from-neon-blue to-neon-purple hover:from-neon-purple hover:to-neon-pink text-white font-semibold py-2 px-6 rounded-lg transition-all duration-300 transform hover:scale-105"
              >
                Accept All
              </button>
              <a
                href="/cookie-policy"
                className="bg-titanium-800 hover:bg-titanium-700 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-300 border border-titanium-700"
              >
                Learn More
              </a>
            </div>
          </div>
          
          <button
            onClick={acceptCookies}
            className="flex-shrink-0 text-gray-400 hover:text-white transition-colors"
            aria-label="Close"
          >
            <FaTimes className="text-xl" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiePopup;


